import React, { useState, useEffect } from "react";
import "./App.css";
import { AppProvider, useApp } from "./context/AppContext";
import { AuthProvider } from "./context/AuthContext";
import BottomNav from "./components/BottomNav";
import Toast from "./components/Toast";
import LoadingScreen from "./screens/LoadingScreen";
import HomeScreen from "./screens/HomeScreen";
import ScanScreenQuadrant from "./screens/ScanScreenQuadrant";
import SustainabilityScreen from "./screens/SustainabilityScreen";
import InsightsScreen from "./screens/InsightsScreen";
import WishlistScreen from "./screens/WishlistScreen";
import AuthScreen from "./screens/AuthScreen";
import HistoryScreen from "./screens/HistoryScreen";
import ProfileScreen from "./screens/ProfileScreen";
import AvatarScreen from "./screens/AvatarScreen";
import SettingsScreen from "./screens/SettingsScreen";
import EditLikenessScreen from "./screens/EditLikenessScreen";
import FollowedBrandsScreen from "./screens/FollowedBrandsScreen";
import ShoppingPreferencesScreen from "./screens/ShoppingPreferencesScreen";
import ContactUsScreen from "./screens/ContactUsScreen";
import HelpScreen from "./screens/HelpScreen";
import URLInputScreen from "./screens/URLInputScreen";
import TagCaptureScreen from "./screens/TagCaptureScreen";
import PhotoCaptureScreen from "./screens/PhotoCaptureScreen";
import BarcodeCaptureScreen from "./screens/BarcodeCaptureScreen";
import AnalyzingScreen from "./screens/AnalyzingScreen";
import ResultsScreenCanva from "./screens/ResultsScreenCanva";
import MaterialBreakdownCanva from "./screens/MaterialBreakdownCanva";
import AlternativesScreenCanva from "./screens/AlternativesScreenCanva";
import AppSettingsScreen from "./screens/AppSettingsScreen";
import AccountScreen from "./screens/AccountScreen";
import ChatAdvisorScreen from "./screens/ChatAdvisorScreen";

const AppContent = () => {
  const { activeTab, currentScreen, toast, hideToast } = useApp();
  const [showLoading, setShowLoading] = useState(true);

  useEffect(() => {
    const hasSeenLoading = sessionStorage.getItem('atelia_loading_shown');
    if (hasSeenLoading) {
      setShowLoading(false);
    }
  }, []);

  const handleLoadComplete = () => {
    sessionStorage.setItem('atelia_loading_shown', 'true');
    setShowLoading(false);
  };

  if (showLoading) {
    return <LoadingScreen onLoadComplete={handleLoadComplete} />;
  }

  const renderScreen = () => {
    switch (currentScreen) {
      case 'auth':
        return <AuthScreen />;
      case 'sustainability':
        return <SustainabilityScreen />;
      case 'settings':
        return <SettingsScreen />;
      case 'edit-likeness':
        return <EditLikenessScreen />;
      case 'followed-brands':
        return <FollowedBrandsScreen />;
      case 'shopping-preferences':
        return <ShoppingPreferencesScreen />;
      case 'contact-us':
        return <ContactUsScreen />;
      case 'help':
        return <HelpScreen />;
      case 'url-input':
        return <URLInputScreen />;
      case 'tag-capture':
        return <TagCaptureScreen />;
      case 'photo-capture':
        return <PhotoCaptureScreen />;
      case 'barcode-capture':
        return <BarcodeCaptureScreen />;
      case 'analyzing':
        return <AnalyzingScreen />;
      case 'results-canva':
        return <ResultsScreenCanva />;
      case 'material-breakdown':
        return <MaterialBreakdownCanva />;
      case 'alternatives-canva':
        return <AlternativesScreenCanva />;
      case 'app-settings':
        return <AppSettingsScreen />;
      case 'account':
        return <AccountScreen />;
      case 'chat-advisor':
        return <ChatAdvisorScreen />;
      default:
        switch (activeTab) {
          case 'home':
            return <HomeScreen />;
          case 'scan':
            return <ScanScreenQuadrant />;
          case 'history':
            return <HistoryScreen />;
          case 'avatar':
            return <AvatarScreen />;
          case 'encyclopedia':
          case 'insights':
            return <InsightsScreen />;
          case 'profile':
            return <ProfileScreen />;
          case 'wishlist':
            return <WishlistScreen />;
          default:
            return <HomeScreen />;
        }
    }
  };

  const hideNav = currentScreen === 'chat-advisor';

  return (
    <div className="app-container">
      {renderScreen()}
      {!hideNav && <BottomNav />}
      <Toast
        message={toast.message}
        type={toast.type}
        isVisible={toast.visible}
        onClose={hideToast}
      />
    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <AppProvider>
        <AppContent />
      </AppProvider>
    </AuthProvider>
  );
}

export default App;
